import { configureAbly, usePresence } from "@ably-labs/react-hooks";
import { ABLY_API_KEY } from "../../utils/apiConfig";
import { getTenantChannelName } from "../../utils/helper";

configureAbly({
  key: ABLY_API_KEY,
  clientId: "admin",
});

export const useAbly = () => {
  const [presenceDataTerminal] = usePresence(
    getTenantChannelName("presence"),
    [],
  );
  const [presenceDataKds] = usePresence(
    getTenantChannelName("presence-kds"),
    [],
  );
  return { presenceDataKds, presenceDataTerminal };
};
